import { useEffect } from 'react';

export default function useScrollGradient(ref) {
    useEffect(() => {
        if (!ref.current) return;

        const el = ref.current;
        const startEl = el.querySelector('[data-scroll-start]');
        const endEl = el.querySelector('[data-scroll-end]');

        if (!startEl || !endEl) return;

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const targetClass = entry.target === startEl ? 'scroll-start' : 'scroll-end';
                if (entry.isIntersecting) {
                    el.classList.add(targetClass);
                } else {
                    el.classList.remove(targetClass);
                }
            });
        }, {
            root: el,
            rootMargin: '1px',
        });

        observer.observe(startEl);
        observer.observe(endEl);

        return () => {
            observer.disconnect();
        };
    }, [ref]);
}
